<template lang="pug">
  #app
    Navigation
    Container
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Navigation from './components/Navigation'
import Container from './views/Container'
import AnimationManager from './scripts/AnimationManager'

export default {
  name: 'app',
  data () {
    return {
    }
  },
  created () {
    this.init(this.$parent.site)
  },
  mounted () {
    // console.log('App Mounted', this.$parent.site)

    const textBlocks = document.querySelectorAll('[data-animate="true"]')
    // console.log(textBlocks)

    textBlocks.forEach((element, index) => {
      // console.log(element, index)
      let tl = new window.TimelineLite({ paused: true })
        .set(element, {opacity: 0})
        .fromTo(element, .75, { opacity: 0, y: 20 }, { opacity: 1, y: 0, ease: window.Power2.easeOut }, 0)

      AnimationManager.onEnterView(element, () => {
        tl.seek(0)
        tl.play()
      })
    });

    AnimationManager.update()

    this.setLoading(false)
  },
  computed: {
    ...mapState(['site', 'loading']),
  },
  methods: {
    ...mapActions(['init', 'setLoading']),
  },
  components: {
    Navigation,
    Container,
  },
}
</script>

<style lang="scss">
@import './styles/main'; 
</style>
